import { ofType } from 'redux-observable';
import { pluck } from 'rxjs/operators';
import { ActionWithPayload } from '@bridebook/web/lib/types';
import { MuteActionsService } from '@bridebook/web/lib/utils/mute-actions-service';
import { SvgIcon } from '@bridebook/aura';

export interface IWarningModalPayload {
  title?: string;
  subtitle?: string | string[];
  confirmText?: string;
  cancelText?: string;
  onConfirm?(): void | Promise<void>;
  onCancel?(): void | Promise<void>;
  onClose?(): void;
  // confirm: primary + cancel buttons
  // accept: primary button only, no cancel
  type?: 'confirm' | 'accept';
  confirmButtonVariant?: 'destructive' | 'primary';
  icon?: SvgIcon;
}
/**
 * A simple service to handle packages/web/components/bbcommon/warning-modal/warning-modal-lazy.tsx component.
 * Use it in thunks/epics/components to show a warning modal:
 *
 * Component example:
 *
 * const { warningModal } = useServices();
 * warningModal.toggleWarningModal({ ... });
 *
 * In epics/thunks it's available trough dependency.
 * `subscribe` method is used to subscribe to the modal state changes and it is meant to be used in warning modal component only.
 */
export class WarningModalService {
  constructor(private muteActions: MuteActionsService) {}

  toggleWarningModal(payload?: IWarningModalPayload) {
    this.muteActions.dispatch({ type: 'TOGGLE_WARNING_MODAL', payload });
  }

  subscribe(callback: (payload?: IWarningModalPayload) => void) {
    return this.muteActions
      .actions()
      .pipe(
        ofType('TOGGLE_WARNING_MODAL'),
        pluck<ActionWithPayload<IWarningModalPayload>, IWarningModalPayload>('payload'),
      )
      .subscribe((payload) => {
        callback(payload);
      });
  }
}
